import React, { useState } from 'react';

export default function WithdrawModal({ isOpen, onClose, fromWalletName, fromAddress, solanaNetwork }) {

  const [toAddress, setToAddress] = useState('');
  const [amountSol, setAmountSol] = useState('');

  if (!isOpen) return null;

  const handleCopyFrom = async () => {
    try {
      await navigator.clipboard.writeText(fromAddress || '');
      alert('Address copied!');
    } catch {
      alert('Ne udalosj skopirovatj adres');
    }
  };

  const handleWithdraw = async () => {
    try {
      const amt = Number((amountSol || '').trim());
      if (!toAddress || !Number.isFinite(amt) || amt <= 0) {
        alert('Nuzno ukazatj korrektnij adres i summu >0');
        return;
      }
      const r = await fetch('/api-auth/withdraw', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ name: fromWalletName, toAddress, amountSol: amt })
      });
      const j = await r.json();
      if (!r.ok || j?.error) throw new Error(j?.error || ('HTTP' + r.status));
      alert(`OK! Tx: ${j.signature}`);
      onClose();
    } catch (e) {
      alert(`Oshibka withdraw: ${e.message || e}`);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 10000
    }}>
      <div style={{
        background: '#111827', color: '#fff',
        borderRadius: 10, padding: 20, minWidth: 360
      }}>
        <h2 style={{ marginBottom: 12 }}>Withdraw SOL</h2>

        <div style={{ fontSize: 14, color: '#d1d5ab', marginBottom: 8 }}>
          <div><b>Wallet:</b> {fromWalletName || '--'}</div>
          <div style={{ wordBreak: 'break-all' }}>
            <b>From address:</b> <span style={{ color: '#10b981' }}>{fromAddress || '--'}</span>
          </div>
          <button
            onClick={handleCopyFrom}
            style={{ 
              marginTop: 8,
              padding: '6px 10px',
              background: '#facc15',
              color: '#1f2937',
              botder: 'none',
              borderRadius: 8,
              fontWeight: 600, 
              cursor: 'pointer'
          }}
        >
          Copy
        </button>
        <div style={{ marginTop: 8 }}>Network: {solanaNetwork || 'mainnet-beta'}</div>
      </div>

      <div style={{ display: 'grid', gap: 8, marginTop: 12 }}>
        <label style={{ fontSize: 14 }}>Recipient address</label>
        <input
          value={toAddress}
          onChange={(e) => setToAddress(e.target.value)}
          placeholder="Enter recipient SOL address"
          style={{
            background: '#1f2937', 
            color: '#fff', 
            border: '1px solid #374151',
            borderRadius: 6, 
            padding: '8px'
          }}
        />

        <label style={{ fontSize: 14, marginTop: 8 }}>Amount (SOL)</label>
        <input
          type="text"
          inputMode="decimal"
          value={amountSol}
          onChange={(e) => setAmountSol(e.target.value.replace(',', '.'))}
          placeholder="0.000000"
          style={{ 
            background: '#1f2937',
            color: '#fff',
            border: '1px solid #374151',
            borderRadius: 6, 
            padding: '8px'
          }}
        />
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }}>
        <button
          onClick={onClose}
          style={{ padding: '8px 12px', background: '#374151', borderradius: 6 }}
        >
          Close
        </button>

        <button
          onClick={handleWithdraw}
          style={{ padding: '8px 12px', background: '#22c55e', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
        >
          Withdraw
        </button>
      </div>
    </div>
  </div>
  );
}



